(function () {
  const PREORDER_HANDLE = 'epsom-long-sleeve-a-line-dress';

  function isPreorderProduct() {
    return window.location.pathname.includes(PREORDER_HANDLE);
  }

  function forcePreorderText() {
    if (!isPreorderProduct()) return;

    const span = document.querySelector('.product-form__submit span');

    if (span && span.textContent.trim() !== 'Pre order now') {
      span.textContent = 'Pre order now';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    forcePreorderText();
  });

  const observer = new MutationObserver(function () {
    forcePreorderText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();